import { render } from "./FilterChip.vue?vue&type=template&id=bf6c3010&ts=true"
import script from "./FilterChip.ts?vue&type=script&lang=ts&external"
export * from "./FilterChip.ts?vue&type=script&lang=ts&external"

import "./FilterChip.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
